
let enabled = false;
let lastActivity = Date.now();
let focusLostTime: number | null = null;
const TIMEOUT_MS = 1800000; 


const onActivity = () => {
  if (enabled && document.hasFocus()) {
    lastActivity = Date.now();
    focusLostTime = null;
  }
};

const onWindowBlur = () => {
  if (enabled) {
    focusLostTime = Date.now();
  }
};

const onWindowFocus = () => {
  if (!enabled) return;

  const now = Date.now();
  const inactiveTime = now - lastActivity;


  if (inactiveTime >= TIMEOUT_MS) {
    window.location.reload();
  } else {
    lastActivity = now;
  }
};


export const enableInactivityGuard = () => {
  if (enabled) return;
  enabled = true;
  lastActivity = Date.now();
  focusLostTime = null;

  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'] as const;
  events.forEach(ev => window.addEventListener(ev, onActivity, true));

  window.addEventListener('blur', onWindowBlur);
  window.addEventListener('focus', onWindowFocus);
};

export const disableInactivityGuard = () => {
  if (!enabled) return;
  enabled = false;

  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'] as const;
  events.forEach(ev => window.removeEventListener(ev, onActivity, true));

  window.removeEventListener('blur', onWindowBlur);
  window.removeEventListener('focus', onWindowFocus);

};